import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import './Menu.scss';
import { isPostWedding } from './after';
import { I18nSwitch } from './i18n/I18nSwitch';

export function Menu({ i18n }) {
    //
    // https://codepen.io/fromwireframes/pen/arMrYp
    //
    const [isOpen, setIsOpen] = useState(false);
    const dref = useRef(null);
    const mref = useRef(null);
    const { menu } = i18n;
    const onChange = () => {
        setIsOpen(prev => !prev);
    }

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isOpen])

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 100) {
                dref.current?.classList.add('top');
                dref.current?.classList.add('gray');
                mref.current?.classList.add('top');
                mref.current?.classList.add('gray');
            } else {
                dref.current?.classList.remove('top');
                dref.current?.classList.remove('gray');
                mref.current?.classList.remove('top');
                mref.current?.classList.remove('gray');
            }
        }
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const close = () => setIsOpen(false);

    const renderMainNavigation = () => {
        return <ul>
            <li>
                <Link to="/" onClick={close}>{menu.root}</Link>
            </li>
            {!isPostWedding() && <li>
                <Link to="/rsvp" onClick={close}>RSVP</Link>
            </li>}
        </ul>;
    };

    const renderTop = () => {
        return <span className="top-name">
            ALEXANDRA & PÉTER
        </span>
    };

    return <>
        <nav className="desktop-nav" ref={dref}>
            {renderMainNavigation()}
            <I18nSwitch />
            {renderTop()}
        </nav>
        <div className="menu">
            <div className="menu-icon">
                <input className="menu-icon__cheeckbox" type="checkbox" checked={isOpen} onChange={onChange} />
                <div><span /><span /></div>
            </div>
            <div className={`menu-overlay ${isOpen ? 'open' : 'closed'}`}>
                <nav>
                    {renderMainNavigation()}
                </nav>
                <div className="menu-icon close">
                    <input className="menu-icon__cheeckbox" type="checkbox" checked={isOpen} onChange={onChange} />
                    <div><span /><span /></div>
                </div>
            </div>
        </div>
        <div className="mobile-nav top" ref={mref}>
            {renderTop()}
            <I18nSwitch />
        </div>
    </>;
}
